module.exports = __webpack_public_path__ + "img/circle3blue.0628a974.png";